// @flow
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import OrderRefundTemplateContainer from 'containers/order/OrderRefundTemplateContainer';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import UserTemplate from 'components/user/UserTemplate';
import PageTemplate from 'components/base/PageTemplate';

type Props = {};

class OrderRefund extends Component<Props> {
  render() {
    return (
      <PageTemplate>
        <header>
          <MainHeadContainer />
          <MainMobileHeadContainer />
        </header>
        <UserTemplate>
          <Helmet>
            <title>환불 요청 | 캐시바이</title>
          </Helmet>
          <OrderRefundTemplateContainer />
        </UserTemplate>
        <MainMobileFooter />
      </PageTemplate>
    );
  }
}

export default OrderRefund;



// WEBPACK FOOTER //
// ./src/pages/OrderRefund.js